import { useEffect } from "react";
import {
  ContentTypeRender,
  useRouterQueryStore,
  useSearch,
  Wrapper,
} from "nystem-components";

const DateExposedField = ({ model, view, wrapper }) => {
  const [value, setValue] = useRouterQueryStore(
    model.saveId || `${model.id}${model.direction}`,
    "int",
  );
  const isTo = model.direction === "to";
  const toDate = isTo && value && new Date(value);

  if (toDate) toDate.setDate(toDate.getDate() + 1);

  useEffect(() => {
    const updateUrl = ({ id, value }) => {
      if (id === model.direction) setValue(value[model.direction]);
    };

    view.on("change", updateUrl);
    if (view.getValue(model.direction) !== value)
      view.setValue({ path: model.direction, value });

    return () => view.off("change", updateUrl);
  }, [model.direction, setValue, value, view]);

  useSearch({
    view,
    id: model.id,
    value: value && (isTo ? `<${toDate.getTime()}` : `>${value - 1}`),
  });

  const containerClass =
    model.className && !wrapper ? model.className.join(" ") : "";

  return (
    <Wrapper className={containerClass}>
      <ContentTypeRender
        items={[
          {
            ...model,
            id: model.direction,
            format: model.inputFormat || "input",
            dateType: ["date"],
          },
        ]}
      />
    </Wrapper>
  );
};

export default DateExposedField;
